import { render, staticRenderFns } from "./StaticModuleContainer.vue?vue&type=template&id=647f7bea&scoped=true&"
import script from "./StaticModuleContainer.vue?vue&type=script&lang=js&"
export * from "./StaticModuleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f7bea",
  null
  
)

export default component.exports